import { combineReducers } from "redux";

import contact_us from "../features/admin/contact_us/slice";

const GetContactUs = combineReducers({
  contact_us: contact_us,
});

export default GetContactUs;
